import jsPDFInvoiceTemplate, { jsPDF, OutputType } from './src/index';


export default jsPDFInvoiceTemplate;
export {
    OutputType,
    jsPDF
}